import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxButtonComponent,
  OnyxIconComponent,
  OnyxMessageComponent,
  OnyxMessageType,
} from '@onyx/angular';
import type { Subject } from 'rxjs';
import { IntegrationsRoute } from '../../../management-panel/integrations/common/enums/integrations-route';
import { FleetHelper } from '../../common/helpers/fleet.helper';
import type { Fleet } from '../../common/interfaces/fleet';
import { FleetModalWarningComponent } from './fleet-modal-warning/fleet-modal-warning.component';

@Component({
  selector: 'app-fleet-modal-warnings',
  imports: [
    FleetModalWarningComponent,
    OnyxMessageComponent,
    TranslatePipe,
    OnyxIconComponent,
    OnyxButtonComponent,
    RouterLink,
    NgTemplateOutlet,
  ],
  templateUrl: './fleet-modal-warnings.component.html',
  styleUrl: './fleet-modal-warnings.component.scss',
  host: {
    '[hidden]': `!telematicsWarning() && !expiryStatuses().errors.length && !expiryStatuses().warnings.length`,
  },
})
export class FleetModalWarningsComponent {
  public readonly vehicle = input.required<Fleet>();
  public readonly close$ = input.required<Subject<void>>();

  public readonly redirectToDocuments = output<void>();
  public readonly redirectToDetails = output<void>();

  protected readonly I18N = 'fleet.fleetModal';

  protected readonly OnyxMessageType = OnyxMessageType;
  protected readonly IntegrationsRoute = IntegrationsRoute;

  protected telematicsWarning = computed(() => {
    if (this.isArchived()) return null;
    if (!this.vehicle()) return 'noVehicleStatus';
    if (!this.vehicle()?.telematics) return 'noTelematics';
    if (!this.vehicle()?.telemetry) return 'noResponse';
    return null;
  });
  protected expiryStatuses = computed(() =>
    FleetHelper.getVehicleExpiryStatuses(this.vehicle()),
  );

  private isArchived = computed(() =>
    this.vehicle() ? FleetHelper.isArchived(this.vehicle()!) : null,
  );
}
